import React from "react";
import { Typography } from "antd";
import { Nav } from "react-bootstrap";

const { Title } = Typography;

const UIFromHeading = ({
  children,
  onLinkPress,
  type,
  level,
  className,
  style,
  link,
  href,
}) => {
  return (
    <Title
      type={type}
      style={{ fontWeight: "normal", ...style }}
      level={level}
      className={className}
    >
      {children}
      {link && (
        <Nav.Link
          style={{
            color: "#2557a7",
            display: "inline",
            padding: 0,
            marginRight: 4,
            marginLeft: 4,
          }}
          href={href}
          onClick={onLinkPress}
        >
          {link}
        </Nav.Link>
      )}
    </Title>
  );
};

export default UIFromHeading;
